<template>
    <div class="container">
        <div class="store-img" v-if="type === 'proxy'"><img :src="`${imgUrl}/proxy_sale.jpg`" /></div>
        <div class="store-img" v-if="type === 'brand'"><img :src="`${imgUrl}/brand_store.jpg`" /></div>
        <div class="store-img" v-if="type === 'union'"><img :src="`${imgUrl}/union_store.jpg`" /></div>
        <div class="feature-img"><img :src="`${imgUrl}/feature_list.jpg`" /></div>
        <div class="buy-btn">
            <van-button class="van-buy-btn" type="primary" @click="openService">购买</van-button>
        </div>
        <div class="gap" />
    </div>
</template>

<script>
    import { getCurrentInstance, ref, onMounted } from 'vue'
    import { customerService } from "@/utils/getCustomerService"
    import { getUrlKey } from '@/utils/util'

    export default {
        name: 'Buy',
        setup() {
            const { proxy } = getCurrentInstance()
            const imgUrl = 'http://image.jxt1314.com/h5/project'
            const type = ref('proxy')

            const openService = () => {
                proxy.$http.post('/base/kefu').then(({ data: res }) => {
                    if (res?.success) {
                        customerService(res.data)
                    } else {
                        proxy.$toast(res.errorMessage)
                    }
                }).catch(err => console.log('err', err))
            }

            onMounted(() => {
                if (getUrlKey('type')) {
                    type.value = getUrlKey('type')
                }
            })

            return {
                imgUrl,
                type,
                openService
            }
        }
    }
</script>

<style scoped lang="scss">
    .container {
        .store-img {
            width: 100vw;
            height: 1161px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .feature-img {
            width: 100vw;
            height: 1028px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .buy-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 100;
            background: #fff;
            padding-top: 10px;
            padding-bottom: calc(constant(safe-area-inset-bottom) + 10px);
            padding-bottom: calc(env(safe-area-inset-bottom) + 10px);

            .van-buy-btn {
                background: #3363DE;
                width: 325px;
                height: 40px;
                border-radius: 8px;
            }
        }

        .gap {
            height: calc(constant(safe-area-inset-bottom) + 60px);
            height: calc(env(safe-area-inset-bottom) + 60px);
        }
    }
</style>